import { chipClassName } from './styles'

export const SRChip = ({ children, className = '' }) => {
  return <div className={`${chipClassName} ${className}`}>{children}</div>
}
